// reducer for contactPersonLookup

// ActionType
import {
  SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER,
  SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER_SUCCESS,
  SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER_ERROR,
} from "./actionType";

// Initial State
const initialState = {
  contactPersonLookup: [],
};

// Reducer
export default function ContactPersonLookup(state = initialState, action) {
  switch (action.type) {
    case SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER:
      return {
        ...state,
      };
    case SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER_SUCCESS:
      return {
        ...state,
        contactPersonLookup: action.payload,
      };
    case SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER_ERROR:
      return {
        ...state,
        contactPersonLookup: [],
      };
    default:
      return state;
  }
}
